// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"f474efd1","366":"c8ad17ff","445":"6c75b9e1","883":"ffcaee50"}[chunkId] + ".chunk.js";
};